import { Container, Grid, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import Modal from "../modal/Modal";
import Skeletons from "../skeleton/Skeleton";
const useStyles = makeStyles(() => {
  return {
    comingsoon: {
      fontFamily: "Rubik",
      fontWeight: 300,
      color: "#757575",
    },
    typoCasestudyfont1: {
      fontFamily: "Rubik",
      fontWeight: 500,
      color: "black",
      //   fontSize: 18,
    },
    typoCasestudyfont2: {
      fontFamily: "Rubik",
      fontWeight: 300,
      color: "#757575",
      //   fontSize: 18,
    },
    typoText: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
    },
    typoTextRight: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
      textAlign: "right",
    },
    typoHeadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 700,
    },
    typoSubheadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 500,
    },
    image: {
      "&:hover": {
        opacity: "0.5",
        transition: "ease-in-out",
        transitionDuration: "0.2s",
      },
    },
    but: {
      fontSize: 20,
    },
  };
});

const Section4 = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Container
        sx={{ paddingTop: 20 }}
        id="ux"
        data-aos="fade-up"
        data-aos-offset="250"
        data-aos-duration="800"
      >
        <Grid container justifyContent="center">
          <Grid item sx={{ textAlign: "center" }}>
            <Typography className={classes.typoHeadline} variant="h3">
              Design tools
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          spacing={6}
          sx={{ marginTop: 3, textAlign: "center" }}
        >
          <Grid item>
            <img
              src="figma.svg"
              width="80%"
              height="80%"
              className={classes.image}
            />
          </Grid>
          <Grid item>
            <img
              src="adobeapps.svg"
              width="80%"
              height="80%"
              className={classes.image}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ marginTop: 1 }}>
          <Grid item xs={12} sx={{ paddingBottom: 1 }}>
            <Typography variant="h5" className={classes.typoSubheadline}>
              Case Study
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{ boxShadow: "2px 2px 8px 3px #E8ECFF" }}
              elevation={1}
              onClick={() => {
                window.open(
                  "https://drive.google.com/file/d/1aL-vmgkav7vwrrL8NLIaXQC-_BHUNXMk/view?usp=sharing"
                );
              }}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="vlg.svg"
                  alt="casestudy"
                />
                <CardContent>
                  <Typography
                    variant="h6"
                    className={classes.typoCasestudyfont1}
                  >
                    Vloggers diary
                  </Typography>
                  <Typography
                    variant="h6"
                    className={classes.typoCasestudyfont2}
                  >
                    Your travel guide
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            <Modal open={open} setOpen={setOpen} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              sx={{ boxShadow: "2px 2px 8px 3px #E8ECFF" }}
              elevation={1}
              onClick={() => {
                window.open(
                  "https://drive.google.com/file/d/13u0QXcWuRkp7RdfASTHQTVa3PA6ByDNS/view?usp=sharing"
                );
              }}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="140"
                  image="youtube.svg"
                  alt="casestudy"
                />
                <CardContent>
                  <Typography
                    variant="h6"
                    className={classes.typoCasestudyfont1}
                  >
                    YouTube
                  </Typography>
                  <Typography
                    variant="h6"
                    className={classes.typoCasestudyfont2}
                  >
                    Mood tracking
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            <Modal open={open} setOpen={setOpen} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Skeletons />
          </Grid>
        </Grid>
        <Grid container justifyContent="center" sx={{ marginTop: 5 }}>
          <Grid item>
            <Typography variant="body2" className={classes.comingsoon}>
              More Coming Soon !
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Section4;
